import React from 'react'
import { Link } from 'react-router-dom'
import { useState } from 'react'
import { FaBars, FaTimes } from 'react-icons/fa'

export const Nav = () => {
    const [click, setClick] = useState(false);
    const handleClick = () => setClick(!click);

    // const [color, setColor] = useState(false);
    // const changeColor = () => {
    //     if (window.scrollY >= 100) {
    //         setColor(true);
    //     } else {
    //         setColor(false);
    //     }
    // };

    // window.addEventListener("scroll", changeColor);
    return (
        <>

            <div className=" flex items-center justify-between p-[1rem] fixed w-full h-[90px] z-50 text-[#595959]  backdrop-blur-[15px] drop-shadow-xl font-[Poppins]">
                <h1 className='text-[2rem] md:text-[2.4rem] pr-[15vw] font-semibold h-full'>
                    <Link to="/" className='h-full'>
                        <img src="https://res.cloudinary.com/dldjt5ca6/image/upload/v1693811487/Group_9381_pjiqm2.png" alt="" className='h-full' />
                    </Link>
                </h1>
                <ul className={click ? ("flex md:flex-row flex-col md:justify-between md:w-[65vw] lg:w-[50vw] justify-center items-center w-full h-[100vh] bg-[rgba(0,0,0,0.9)] text-white md:text-black md:bg-transparent  left-0 absolute top-0 -z-[3] transition-all duration-[1s] md:h-auto md:relative md:left-0 md:top-0") : ("flex md:flex-row flex-col md:justify-between md:w-[65vw] lg:w-[50vw] justify-center items-center  w-full h-[100vh] -z-[3] bg-[rgba(0,0,0,0.9)] text-white md:text-[#595959] md:bg-transparent  left-[-100%] absolute top-0 transition-all duration-[1s] md:h-auto md:relative md:left-0 md:top-0")}>
                    <li className='md:py-0 px-0 py-[1rem]'>
                        <Link to="/" className=' text-[2rem] md:text-[1.2rem] font-bold'> Home </Link>
                    </li>
                    <li className='md:py-0 px-0 py-[1rem]'>
                        <Link to="/events" className=' text-[2rem] md:text-[1.2rem] font-bold'> Events </Link>
                    </li>
                    <li className='md:py-0 md:px-[1rem] px-0 py-[1rem]'>
                        <Link to="/team" className=' text-[2rem] md:text-[1.2rem] font-bold'> Teams </Link>
                    </li>
                   

                    <li className='md:py-0 px-0 py-[1rem]'>
                        <Link to="/gallery" className=' text-[2rem] md:text-[1.2rem] font-bold'> Gallery </Link>
                    </li>
                    <li className='md:py-0 px-0 py-[1rem]'>
                        <Link to="/about" className=' text-[2rem] md:text-[1.2rem] font-bold'> About </Link>
                    </li>
                    {/* <li className='md:py-0 px-0 py-[1rem]'>
                        <Link to="/merch" className=' text-[2rem] md:text-[1.2rem] font-bold'> Merch </Link>
                    </li> */}
                    {/* <li className='md:py-0 px-0 py-[1rem]'>
                        <Link to="/team" className=' text-[2rem] md:text-[1.2rem] font-bold'> Teams </Link>
                    </li> */}
                </ul>
                <div className=' md:hidden' onClick={handleClick}>
                    {click ? (<FaTimes size={20} style={{ color: "#fff" }} />)
                        : (
                            <FaBars size={20} style={{ color: "#000" }} />
                        )}
                </div>
            </div>
        </>
    )
}